import { useCallback, useEffect, useState } from "react";

import { AxiosPositionsAPI } from "../positions/Api";
import _ from "lodash";
import { useQuery } from "react-query";
import { useSettings } from "./Settings";

export const useQueryWithPagination = (options) => {
  const [page, setPage] = useState(1);
  const { queryKey, queryFn, ...queryFnParameters } = options
  const currentQueryFnParameters = {
    ...queryFnParameters,
    page: page
  }

  useEffect(() => {
    setPage(1);
  }, queryKey);

  const queryState = useQuery({
    queryKey: [...queryKey, page],
    queryFn: ({ signal }) => queryFn(currentQueryFnParameters, { signal }),
    keepPreviousData: true
  });

  const handleNext = () => {
    if (!queryState.data?.next) return;
    setPage(page + 1);
  }
  const handlePrevious = () => {
    if (!queryState.data?.previous) return;
    setPage(Math.max(1, page - 1));
  }

  return { ...queryState, handleNext, handlePrevious };
};

export const useDebouncedSearch = (initialState = "", wait = 500) => {
  const [search, setSearch] = useState(initialState);
  const [debouncedSearch, setDebouncedSearch] = useState(initialState);
  const setDebounced = useCallback(_.debounce(setDebouncedSearch, wait), []);

  const setBoth = searchQuery => {
    setSearch(searchQuery);
    setDebounced(searchQuery);
  };

  return [search, debouncedSearch, setBoth];
};

export const useSettingValue = settingKey => {
  const { data: dataSettings } = useSettings();
  const setting = (dataSettings || []).find(setting => setting.key === settingKey);

  // TODO: Check this logic: "undefined ==> false ????"
  switch (setting?.value) {
    case "True":
      return true;
    case "False":
      return false;
    case undefined:
      return false;
    default:
      return setting.value;
  }
};

export const useSystemSetting = settingKey => {
  const { data: dataSettings } = useSettings();
  const setting = (dataSettings || []).find(setting => setting.key === settingKey);
  return setting?.value
};

export const useSeniorityLevels = () => {
  const { data: seniorityLevels, isLoading } = useQuery(
    ["seniority_levels"],
    () => AxiosPositionsAPI.getSeniorityLevels({})
  );

  return { seniorityLevels, isLoading };
};

export const useFunctionWithDelay = (fn, wait = 500) => {
  const delayedFn = useCallback(_.debounce(fn, wait), []);
  return delayedFn;
};
